import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes, { string } from 'prop-types';
import Modal from '../common/Modal/Modal';
import GeoMapExportForm from './GeoMapExportForm';
import {
  exportGeoMap,
  setExportSpinnerWarningInfoMsg,
  setExportSpinnerFlag,
} from '../../actions/geoMappingActions';
import { EXPORT_FROM_GEOMAPPING } from '../../trackerConstants';
import ExportSpinner from '../common/ExportSpinner';
import { GEO_MAP_VIEW, LABLE_VIEW, TABLE_MAP_VIEW } from './GeoMapConstant';
import { buildGeoMapExportRequest } from '../../util/geomapUtils';
import { exportFileTitle } from '../../util/CommonUtils';

export const geoMapExportModal = {
  ref: null,
  styles: {
    width: '328px',
    height: '218px',
    top: '28%',
    left: '40%',
  },
};

class GeoMapToolPalette extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exportInProgress: false,
      isPPTExportInProgress: false,
      // exportInProgressInfoMsg: false,
    };
  }

  setSpinnerFlagAfterExport = () => {
    const SpinnerFlagsAfterDownload = [];
    SpinnerFlagsAfterDownload.push(this.props.setExportSpinnerFlag(false));
    SpinnerFlagsAfterDownload.push(
      this.props.setExportSpinnerWarningInfoMsg(false)
    );
    return SpinnerFlagsAfterDownload;
  };

  handleGeoMapExportClick = () => {
    this.props.setExportSpinnerWarningInfoMsg(false);
    // only show modal if export is not in progress...
    if (!this.state.exportInProgress) {
      geoMapExportModal.ref.show();
    }
  };

  handleExportGeoMap = (fileName, fileType) => {
    const {
      trackerFn,
      login,
      study,
      weightType,
      base,
      target,
      geoMapData,
      selectedGeoMapTabIndex,
      originalTitles,
      geoMapSettingsData,
    } = this.props;
    const exportRequest = buildGeoMapExportRequest(
      fileName,
      fileType,
      study,
      weightType,
      base,
      target,
      geoMapData,
      selectedGeoMapTabIndex,
      originalTitles,
      geoMapSettingsData,
      true // exporting all in PPT
    );
    this.setState({ exportInProgress: true });
    if (fileType === 'pptx') {
      this.setState({ isPPTExportInProgress: true });
    } else {
      this.props.setExportSpinnerFlag(true);
    }
    trackerFn({ action: EXPORT_FROM_GEOMAPPING });
    setTimeout(() => {
      if (this.state.exportInProgress === true) {
        this.props.setExportSpinnerWarningInfoMsg(true);
      }
    }, 15000);
    exportGeoMap(login.uid, login.currentAccountId, exportRequest)
      .then(response => response.json())
      .then(response => {
        if (response) {
          window.open(response.data.url, '_self');
        }
      })
      .finally(() => {
        if (fileType === 'pptx') {
          this.setState({ isPPTExportInProgress: false, exportInProgress: false });
        } else {
          Promise.all(this.setSpinnerFlagAfterExport()).then(() => {
            this.setState({
              exportInProgress: false,
            });
          });
        }
      });
  };

  render() {
    const {
      login,
      study,
      weightType,
      base,
      target,
      geoMapData,
      selectedGeoMapTabIndex,
      originalTitles,
      exportSpinnerProgressFlag,
      // exportSpinnerWarningInfoMsg,
      showHeatMap,
    } = this.props;

    return (
      <div
        className="width-20 minimize-tp float-left"
        data-test="geoMapToolPaletteComponent"
      >
        <ul className="accordion tool_bg geomap-export">
          <li className="accordion__item">
            <input
              type="checkbox"
              className="accordion__toggle"
              id="toggle-01"
            />
            <label
              className="accordion__trigger tool_img export_tool_qr metrics_tool"
              htmlFor="toggle-01"
              title="Export"
            >
              Export
            </label>
            <div className="accordion__target padding-rl20">
              <button
                type="button"
                id="export_btn"
                className="exportBtnDiv chart-type"
                onClick={this.handleGeoMapExportClick}
              >
                {this.props.sideBarChecked === false && (
                  <div className="exportSpinner">
                    <p
                      className="table-view geo-export-btn-txt"
                      title="Export .XLS"
                    >
                      Export .XLS
                    </p>
                    {exportSpinnerProgressFlag === true && (
                      <span
                        className="export_spinner_icon"
                        data-test="exportSpinner"
                      >
                        <ExportSpinner name="export" size={15} thickness={7} />
                      </span>
                    )}
                  </div>
                )}
              </button>
              <button
                type="button"
                id="export_btn"
                className="exportBtnDiv chart-type"
                onClick={() =>
                  this.handleExportGeoMap(exportFileTitle('GeoMapping'), 'pptx')
                }
                disabled={!this.props.heatMapView}
              >
                <div className="exportSpinner">
                  <p
                    className={`geo-map geo-export-btn-txt ${
                      !this.props.heatMapView ? 'export-disabled' : ''
                    }`}
                    title="Export PPT"
                  >
                    Export PPT
                  </p>
                  {this.state.isPPTExportInProgress === true && (
                    <span
                      className="export_spinner_icon"
                      data-test="exportSpinner"
                    >
                      <ExportSpinner name="export" size={15} thickness={7} />
                    </span>
                  )}
                </div>
              </button>
            </div>
          </li>
          <li className="accordion__item">
            <input
              type="checkbox"
              className="accordion__toggle"
              id="toggle-02"
            />
            <label
              className="accordion__trigger tool_img  metrics_tool"
              htmlFor="toggle-02"
              title="View"
            >
              {LABLE_VIEW}
            </label>
            <div className="accordion__target padding-rl20">
              <button
                type="button"
                className="chart-type"
                onClick={() => showHeatMap(GEO_MAP_VIEW)}
                disabled={[3,4].includes(selectedGeoMapTabIndex)} // Heatmap button disabled from left nav for [county, zipcode] based on tab index 
              >
                <p className="geo-map" title={GEO_MAP_VIEW}>
                  {GEO_MAP_VIEW}
                </p>
              </button>
              <button
                type="button"
                className="chart-type"
                onClick={() => showHeatMap(TABLE_MAP_VIEW)}
              >
                <p className="table-view" title={TABLE_MAP_VIEW}>
                  {TABLE_MAP_VIEW}
                </p>
              </button>
            </div>
          </li>
        </ul>
        <Modal
          data-test="geoMapExportModal"
          title="Export"
          ref={node => {
            geoMapExportModal.ref = node;
          }}
          dialogStyles={geoMapExportModal.styles}
        >
          {/* only show if study, target, and at least one geomap loaded */}
          {study &&
          target.length &&
          Object.values(geoMapData).some(i => i.length) ? (
            <GeoMapExportForm
              data-test="geoMapExportForm"
              closeGeoMapExportModal={() => geoMapExportModal.ref.hide()}
              login={login}
              study={study}
              weightType={weightType}
              base={base}
              target={target}
              geoMapData={geoMapData}
              selectedGeoMapTabIndex={selectedGeoMapTabIndex}
              originalTitles={originalTitles}
              exportGeoMap={this.handleExportGeoMap}
            />
          ) : (
            <span data-test="geoMapExportNoData">
              A target and at least one geography are required for export.
            </span>
          )}
        </Modal>
      </div>
    );
  }
}

GeoMapToolPalette.propTypes = {
  login: PropTypes.shape(),
  study: PropTypes.shape(),
  weightType: PropTypes.shape(),
  base: PropTypes.arrayOf(Object),
  target: PropTypes.arrayOf(Object),
  geoMapData: PropTypes.shape(),
  geoMapSettingsData: PropTypes.shape(Object),
  selectedGeoMapTabIndex: PropTypes.number,
  originalTitles: PropTypes.instanceOf(Object),
  trackerFn: PropTypes.func,
  setExportSpinnerFlag: PropTypes.func,
  setExportSpinnerWarningInfoMsg: PropTypes.func,
  sideBarChecked: PropTypes.bool,
  exportSpinnerProgressFlag: PropTypes.bool,
  exportSpinnerWarningInfoMsg: PropTypes.bool,
  // handleGeoMapExportClick: PropTypes.func,
  showHeatMap: PropTypes.func,
  heatMapView: string,
};

const mapStateToProps = ({ login, study, geomap }) => {
  const { geoMapStudy, geoWeightTypes } = study;
  const {
    BaseDataGridData,
    TargetDataGridData,
    geographicsTableData,
    selectedGeographicsTabIndex,
    originalTitles,
    mapSettings,
  } = geomap;

  return {
    login: login.loginResponse.data,
    study: geoMapStudy,
    weightType: geoWeightTypes,
    base: BaseDataGridData,
    target: TargetDataGridData,
    geoMapData: geographicsTableData,
    selectedGeoMapTabIndex: selectedGeographicsTabIndex,
    originalTitles,
    geoMapSettingsData: mapSettings,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setExportSpinnerFlag: bindActionCreators(setExportSpinnerFlag, dispatch),
    setExportSpinnerWarningInfoMsg: bindActionCreators(
      setExportSpinnerWarningInfoMsg,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeoMapToolPalette);
